<script>
/**
 * Descripción: Contenedor de la aplicación
 *
 * @displayName App
 */

import TheLayout from '@/components/core/layouts/TheLayout';

export default {
  name: 'App',

  components: {
    TheLayout
  }
};
</script>

<template>
  <v-app id="inspire">
    <TheLayout>
      <!-- @slot Use este slot para el contenido -->
      <div slot="RenderBody">
        <router-view />
      </div>
    </TheLayout>
  </v-app>
</template>

<style>
html {
  overflow-y: auto !important;
}

html::-webkit-scrollbar {
  width: 8px; /* Tamaño del scroll en vertical */
  height: 8px; /* Tamaño del scroll en horizontal */
  display: none; /* Ocultar scroll */
}

/* Ponemos un color de fondo y redondeamos las esquinas del thumb */
html::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

/* Cambiamos el fondo y agregamos una sombra cuando esté en hover */
html::-webkit-scrollbar-thumb:hover {
  background: #b3b3b3;
  box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);
}

/* Cambiamos el fondo cuando esté en active */
html::-webkit-scrollbar-thumb:active {
  background-color: #999999;
}

/* Ponemos un color de fondo y redondeamos las esquinas del track */
html::-webkit-scrollbar-track {
  background: #e1e1e1;
  border-radius: 4px;
}

/* Cambiamos el fondo cuando esté en active o hover */
html::-webkit-scrollbar-track:hover,
html::-webkit-scrollbar-track:active {
  background: #d4d4d4;
}
</style>
